import React from 'react';
import { LuSearch } from 'react-icons/lu';

// Form controls with one look across the dashboard. The `ui-control` class lives in index.css.

/**
 * A labelled form field: label on top, the control, then an optional hint.
 */
export const Field = ({ label, hint, className = '', children }) => {
  return (
    <label className={`flex min-w-0 flex-col gap-1.5 ${className}`}>
      <span className="text-[13px] font-medium text-ui-ink-2">{label}</span>
      {children}
      {hint && <span className="text-xs text-ui-ink-3">{hint}</span>}
    </label>
  );
};

export const Input = ({ className = '', ...props }) => {
  return <input className={`ui-control ${className}`} {...props} />;
};

export const Select = ({ className = '', children, ...props }) => {
  return (
    <select className={`ui-control pr-8 ${className}`} {...props}>
      {children}
    </select>
  );
};

export const Textarea = ({ className = '', ...props }) => {
  return <textarea className={`ui-control h-auto min-h-20 py-2 ${className}`} {...props} />;
};

/**
 * Text input with a magnifier icon, for filtering a list on the page.
 */
export const SearchInput = ({ className = '', ...props }) => {
  return (
    <div className={`relative ${className}`}>
      <LuSearch aria-hidden className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-ui-ink-3" />
      <input type="search" className="ui-control pl-9" {...props} />
    </div>
  );
};
